var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7186 7.5559L3.16237 1.6434C3.07346 1.59428 2.97168 1.5734 2.87061 1.58356C2.76953 1.59372 2.67394 1.63442 2.59657 1.70025C2.51921 1.76608 2.46372 1.85392 2.43752 1.95206C2.41131 2.05021 2.41562 2.15401 2.44987 2.24965L4.43737 7.82465C4.48116 7.93289 4.48116 8.05391 4.43737 8.16215L2.44987 13.7372C2.41562 13.8328 2.41131 13.9366 2.43752 14.0347C2.46372 14.1329 2.5192 14.2207 2.59657 14.2866C2.67394 14.3524 2.76953 14.3931 2.8706 14.4032C2.97168 14.4134 3.07345 14.3925 3.16237 14.3434L13.7186 8.4309C13.7968 8.38766 13.8619 8.32428 13.9073 8.24734C13.9526 8.1704 13.9766 8.08272 13.9766 7.9934C13.9766 7.90409 13.9526 7.8164 13.9073 7.73946C13.8619 7.66252 13.7968 7.59914 13.7186 7.5559Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7186 7.5559L3.16237 1.6434C3.07346 1.59428 2.97168 1.5734 2.87061 1.58356C2.76953 1.59372 2.67394 1.63442 2.59657 1.70025C2.51921 1.76608 2.46372 1.85392 2.43752 1.95206C2.41131 2.05021 2.41562 2.15401 2.44987 2.24965L4.43737 7.82465C4.48116 7.93289 4.48116 8.05391 4.43737 8.16215L2.44987 13.7372C2.41562 13.8328 2.41131 13.9366 2.43752 14.0347C2.46372 14.1329 2.5192 14.2207 2.59657 14.2866C2.67394 14.3524 2.76953 14.3931 2.8706 14.4032C2.97168 14.4134 3.07345 14.3925 3.16237 14.3434L13.7186 8.4309C13.7968 8.38766 13.8619 8.32428 13.9073 8.24734C13.9526 8.1704 13.9766 8.08272 13.9766 7.9934C13.9766 7.90409 13.9526 7.8164 13.9073 7.73946C13.8619 7.66252 13.7968 7.59914 13.7186 7.5559Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.99316L8.5 7.99316",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.99316L8.5 7.99316",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send.ea55fdcd7b54d2c66588728c996b3627.svg";